import { Hotel } from 'tokyu-hooks'
import { toHotelDetailModel } from 'core/hotels'

export const QUERY_HOTEL_DETAIL_KEY = 'QUERY_HOTEL_DETAIL_KEY'

export const fetchHotelDetail =
  (clientSession: string, _?: string) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [_key, { hotelCode, locale }] = queryKey

    if (!hotelCode) return null

    const res = await Hotel.hotelDetail({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession: clientSession,
      hotelCode,
      locale,
    })

    return !!res?.data?.data ? toHotelDetailModel(res?.data?.data) : null
  }
